module.exports = __webpack_public_path__ + "static/media/hull_color_style_0008.13109236.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hullColors/hull_color_style_0008.jpg
// module id = 626
// module chunks = 0